var _g, _g2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoActiveServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.39 7h-7.023a3.29 3.29 0 0 0-3.29 3.29v10.383a3.29 3.29 0 0 0 3.29 3.29h7.023a3.29 3.29 0 0 0 3.29-3.29V10.29A3.29 3.29 0 0 0 40.39 7z",
    fill: "url(#p4l0slbh4a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.313 7H10.29A3.29 3.29 0 0 0 7 10.29v10.383a3.29 3.29 0 0 0 3.29 3.29h7.023a3.29 3.29 0 0 0 3.29-3.29V10.29A3.29 3.29 0 0 0 17.313 7z",
    fill: "url(#p2jex5enab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.39 30.753h-7.023a3.29 3.29 0 0 0-3.29 3.29v10.383a3.29 3.29 0 0 0 3.29 3.29h7.023a3.29 3.29 0 0 0 3.29-3.29V34.043a3.29 3.29 0 0 0-3.29-3.29z",
    fill: "url(#aafjj0k6bc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.313 30.753H10.29A3.29 3.29 0 0 0 7 34.043v10.383a3.29 3.29 0 0 0 3.29 3.29h7.023a3.29 3.29 0 0 0 3.29-3.29V34.043a3.29 3.29 0 0 0-3.29-3.29z",
    fill: "url(#r2sfivxy1d)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.964 24.127.233-.234c-2.683-.303-4.713-1.82-4.713-3.616v-9.59c0-2.03 2.566-3.687 5.74-3.687h-3.407c-3.173 0-5.74 1.657-5.74 3.687v9.59c0 2.03 2.567 3.686 5.74 3.686h2.147v.164z",
    fill: "url(#8kjkh9q7qe)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.887 24.127.233-.234c-2.683-.303-4.713-1.82-4.713-3.616v-9.59c0-2.03 2.566-3.687 5.74-3.687H12.74C9.567 7 7 8.657 7 10.687v9.59c0 2.03 2.567 3.686 5.74 3.686h2.147v.164z",
    fill: "url(#19o0pi76rf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.964 47.88.233-.234c-2.683-.303-4.713-1.82-4.713-3.617v-9.59c0-2.03 2.566-3.686 5.74-3.686h-3.407c-3.173 0-5.74 1.656-5.74 3.686v9.59c0 2.03 2.567 3.687 5.74 3.687h2.147v.163z",
    fill: "url(#fv7u7w4kcg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.887 47.88.233-.234c-2.683-.303-4.713-1.82-4.713-3.617v-9.59c0-2.03 2.566-3.686 5.74-3.686H12.74c-3.173 0-5.74 1.656-5.74 3.686v9.59c0 2.03 2.567 3.687 5.74 3.687h2.147v.163z",
    fill: "url(#xqknhshpwh)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.354 7h-9.59a3.687 3.687 0 0 0-3.687 3.687v9.59a3.687 3.687 0 0 0 3.687 3.686h9.59a3.687 3.687 0 0 0 3.686-3.686v-9.59A3.687 3.687 0 0 0 43.354 7z",
    stroke: "url(#244psn0evi)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.277 7h-9.59A3.687 3.687 0 0 0 7 10.687v9.59a3.687 3.687 0 0 0 3.687 3.686h9.59a3.687 3.687 0 0 0 3.686-3.686v-9.59A3.687 3.687 0 0 0 20.277 7z",
    stroke: "url(#gg9k1ovfpj)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.354 30.753h-9.59a3.687 3.687 0 0 0-3.687 3.686v9.59a3.687 3.687 0 0 0 3.687 3.687h9.59a3.687 3.687 0 0 0 3.686-3.687v-9.59a3.687 3.687 0 0 0-3.686-3.686z",
    stroke: "url(#opov92r8mk)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.277 30.753h-9.59A3.687 3.687 0 0 0 7 34.439v9.59a3.687 3.687 0 0 0 3.687 3.687h9.59a3.687 3.687 0 0 0 3.686-3.687v-9.59a3.687 3.687 0 0 0-3.686-3.686z",
    stroke: "url(#0zgytknx1l)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p4l0slbh4a",
    x1: 7,
    y1: 30.677,
    x2: 44.07,
    y2: 19.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p2jex5enab",
    x1: 7,
    y1: 30.677,
    x2: 44.07,
    y2: 19.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aafjj0k6bc",
    x1: 7,
    y1: 30.677,
    x2: 44.07,
    y2: 19.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r2sfivxy1d",
    x1: 7,
    y1: 30.677,
    x2: 44.07,
    y2: 19.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8kjkh9q7qe",
    x1: 7,
    y1: 30.772,
    x2: 40.185,
    y2: 22.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "19o0pi76rf",
    x1: 7,
    y1: 30.772,
    x2: 40.185,
    y2: 22.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv7u7w4kcg",
    x1: 7,
    y1: 30.772,
    x2: 40.185,
    y2: 22.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xqknhshpwh",
    x1: 7,
    y1: 30.772,
    x2: 40.185,
    y2: 22.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "244psn0evi",
    x1: 7,
    y1: 30.677,
    x2: 46.858,
    y2: 17.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gg9k1ovfpj",
    x1: 7,
    y1: 30.677,
    x2: 46.858,
    y2: 17.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "opov92r8mk",
    x1: 7,
    y1: 30.677,
    x2: 46.858,
    y2: 17.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0zgytknx1l",
    x1: 7,
    y1: 30.677,
    x2: 46.858,
    y2: 17.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActiveServices);
export default __webpack_public_path__ + "static/media/noActiveServices.1f117c37277ad3d4476b5290c21c18e9.svg";
export { ForwardRef as ReactComponent };